<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import OperatorModal from "./OperatorModal.vue"
import OperatorEditModal from "./OperatorEditModal.vue"
import OperatorChangePassModal from "./OperatorChangePassModal.vue"
import OperatorsTable from "./OperatorsTable.vue"

const title = "مدیریت اپراتورها"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت اپراتورها",
    active: true,
  },
])

const DEFAULT_OPERATOR = {
  id: "",
  first_name: "",
  last_name: "",
  phone_number: "",
  email: "",
  password: "",
  password_confirmation: "",
  status: "",
}


const operatorModel = ref({ ...DEFAULT_OPERATOR })
const showOperatorModal = ref(false)
const showOperatorEditModal = ref(false)
const showOperatorChangePassModal = ref(false)

const showAddNewModal = () => {
  showOperatorModal.value = true
}

const showChangePassModal = () => {
  showOperatorChangePassModal.value = true
}

const showEditModal = () => {
  showOperatorEditModal.value = true
}

const editOperator = (ope) => {
  operatorModel.value = ope
  showEditModal()
}

const changePassOperator = (ope) => {
  operatorModel.value = ope
  showChangePassModal()
}

const onModalClose = () => {
  operatorModel.value = { ...DEFAULT_OPERATOR }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="operatorList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست اپراتورها</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن اپراتور
                    جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- operators table  -->

          <OperatorsTable @clickEdit="editOperator" @clickChangePass="changePassOperator" />

          <!-- add and edit operator modal  -->

          <OperatorModal
            v-model="showOperatorModal"
            :operator="operatorModel"
            @close="onModalClose"
          />

          <OperatorEditModal
            v-model="showOperatorEditModal"
            :operator="operatorModel"
            @close="onModalClose"
          />

          <OperatorChangePassModal
            v-model="showOperatorChangePassModal"
            :operator="operatorModel"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
